import { useEffect, useState } from 'react';
import { useNavigate } from "react-router";

import Loading from './shared/loading/Loading'
import { Authentication, } from 'shared/topchef.types';
import api from 'shared/topchef-api-places';
import './App.css';

import UnknownUser from './shared/unknown-user/UnknownUser';


const App = () => {

  const [isAuthenticated, setAuthenticated] = useState<boolean>(false);
  const [authenticationFailed, setAuthenticationFailed] = useState<boolean>(false);


  const navigate = useNavigate();

  useEffect(() => {

    if (isAuthenticated || authenticationFailed) {
      return;
    }

    async function authenticate() {
      try {
        const auth: Authentication = await api.authenticate();

        if (auth.type === "place") {
          navigate('/places');
        }
        else if (auth.type === "backoffice") {
          navigate('/backoffice');
        }
        else {
          new Error("type d'utilisateur inconnu");
        }

        setAuthenticated(true);
      } catch (error: any) {
        setAuthenticationFailed(true);
      } 
    }

    authenticate();
  }, );

  if (authenticationFailed) {
    return (
      <UnknownUser />
    );
  }

  return (
    <Loading />
  );

}

export default App;
